import React from "react";
import Search from "../assets/icons/search.svg";
// import notification from '../assets/icons/Notification2.svg'
import calendar from "../assets/icons/Calendar.svg";
import time from "../assets/icons/time.svg";
import bgImg from "../assets/images/pattern.svg";
import { motion } from "framer-motion";
import DashboardLayout from "./DashboardLayout";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const YOUTUBE_VIDEO_ID = "iT1d1kqZGh4";

const Overview = () => {
  // Use the next year for the JAMB UTME once we're past March of the current year.
  // Jan–Mar: show current year. Apr–Dec: show next year.
  const now = new Date();
  const currentYear = now.getFullYear();
  const examYear = now.getMonth() > 2 ? currentYear + 1 : currentYear;
  const navigate = useNavigate();
  // Click-to-play: keeps YouTube's pre-play card (channel name/avatar/
  // "Watch on YouTube") from ever rendering. We show our own thumbnail +
  // play button, and only mount the real iframe once the user clicks.
  const [videoStarted, setVideoStarted] = useState(false);

  const handleSearchClick = () => {
    navigate("/brochure-by-institution");
  };

  return (
    <DashboardLayout overview="Overview">
      <div className="flex items-start justify-between w-full h-[100vh] mb-20">
        <div className="relative flex flex-col items-center justify-start w-full mt-0 md:w-[70%] pb-[200px] md:pb-[125px] lg:mt-0 xl:w-[75%] xl:pb-[180px]">
          {/*FIRST CONTAINER*/}
          <div className="relative z-20 flex flex-col items-center justify-start w-full bg-gradient-to-r from-[#15632B] to-[#25A249] h-60 pt-8 md:h-48 lg:h-44 xl:pt-9 xl:h-52">
            {/* BACKGROUND PATTERN */}
            <div
              className="absolute top-0 inset-0 w-full h-full bg-left bg-no-repeat"
              style={{ backgroundImage: `url(${bgImg})` }}
            ></div>
            {/*SEARCH*/}
            <div className="relative h-9 w-[90%] xl:h-11">
              <input
                onClick={handleSearchClick}
                className="border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[12px] font-normal pl-9 outline-[#25A249] xl:text-sm xl:pl-12 xl:rounded-lg cursor-pointer"
                placeholder="Search anything"
              />
              <img
                className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
                src={Search}
                alt="search_icon"
              />
            </div>

            {/* <motion.div
                    animate={{opacity: [0.3, 0.5, 0.7, 1], scale: 1 }} transition={{ duration: 1, delay: 0.3, }}
                     className='absolute top-[105px] flex items-start justify-start w-[90%] bg-white border-[1px] border-[#DDE1E6] rounded-md p-4 xl:rounded-lg xl:top-[125px] xl:p-5'>
                        <div className='flex items-center justify-center w-7 h-7 bg-[#DFF1EA] rounded-full xl:w-9 xl:h-9'>
                            <img className='w-3 xl:w-[15px]' src={notification} alt='notification_icon' />
                        </div>
                        <div className='flex flex-col items-start justify-start w-[90%] ml-3 -mt-1 xl:ml-6'>
                          <p className='text-base text-black font-semibold lg:text-lg xl:text-[22px]'>
                              Message from the Registrar
                          </p>
                          <p className='text-[10px] text-[#667085] font-normal pt-1 xl:pt-3 xl:text-xs'>
                             The Registrar, Joint Admissions and Matriculation Board (JAMB), Prof. Ishaq Oloyede has blasted parents for encouraging their children to cheat in examinations, stating that such parents should seek God’s forgiveness.
                             <br />
                             <br />
                             He made this remark at the Board’s headquarters in Bwari, Abuja, when a suspected impersonator arrested by officials of the Nigeria Security and Civil Defence Corps (NSCDC), was paraded for attempting to write the UTME for his brother.
                             <br />
                             <br />
                             Oloyede told newsmen that, “Parents need to dissociate themselves from this type of shameful attitude“
                          </p>
                        </div>
                    </motion.div> */}
            <div className="mr-auto pl-12 pt-8">
              <p className="text-base text-white font-semibold lg:text-lg xl:text-[22px]">
                A step by step guide
              </p>
            </div>
          </div>
          {/*THIRD CONTAINER*/}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0.3, 0.5, 0.7, 1], scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            className="absolute top-36 z-0 flex flex-col items-start w-[90%] pb-10 "
          >
            <div className="w-full relative aspect-video mt-2 overflow-hidden rounded-md xl:rounded-lg bg-black">
              {videoStarted ? (
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3&fs=1`}
                  title="IBASS Video"
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
              ) : (
                <button
                  type="button"
                  onClick={() => setVideoStarted(true)}
                  aria-label="Play video"
                  className="absolute inset-0 w-full h-full group"
                >
                  <img
                    src={`https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <span className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="flex items-center justify-center w-16 h-16 xl:w-20 xl:h-20 rounded-full bg-[#25A249] group-hover:bg-[#1f8a3d] transition-colors shadow-lg">
                      <svg
                        className="w-6 h-6 xl:w-8 xl:h-8 text-white ml-1"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </span>
                  </span>
                </button>
              )}
            </div>
          </motion.div>

          {/*SECOND CONTAINER MOBILE SCREEN*/}
          <div className="relative top-[315px] flex items-center justify-between w-[90%] md:hidden">
            <motion.div
              animate={{
                opacity: [0.3, 0.5, 0.7, 1],
                scale: 1,
                x: ["-35%", "0%"],
              }}
              transition={{ duration: 2, delay: 0.3 }}
              className="flex flex-col items-start justify-center w-[48%] border-[1px] border-[#DDE1E6] rounded p-3 h-[135px]"
            >
              <div className="flex items-center justify-between w-full">
                <p className="text-[10px] text-[#101828] font-medium">EVENTS</p>
                <div className="flex items-center justify-center w-6 h-6 bg-[#DFF1EA] rounded">
                  <img
                    className="w-[10px]"
                    src={calendar}
                    alt="calendar_icon"
                  />
                </div>
              </div>
              <div className="flex flex-col items-start w-full mt-5">
                {/* <p className='text-[9px] text-[#667085] font-medium'>
                                JUNE
                            </p> */}
                <p className="text-xl text-[#101828] font-semibold">
                  {examYear}
                </p>
                <p className="text-[9px] text-[#667085] font-normal">
                  Upcoming JAMB exam (UTME)
                </p>
              </div>
            </motion.div>

            <motion.div
              animate={{
                opacity: [0, 0.1, 0.3, 0.5, 0.7, 1],
                scale: 1,
                x: ["35%", "0%"],
              }}
              transition={{ duration: 2, delay: 0.7 }}
              initial={{ opacity: 1, scale: 1 }}
              className="flex flex-col items-start justify-start w-[48%] border-[1px] border-[#DDE1E6] rounded p-3 h-[135px]"
            >
              <div className="flex items-start justify-between w-full">
                <div>
                  <p className="text-[10px] text-[#101828] font-medium">
                    COUNTDOWN
                  </p>
                  <p className="text-[9px] text-[#667085] font-normal w-[95%]">
                    For registration announcement coming soon
                  </p>
                </div>
                <div className="flex items-center justify-center w-6 h-6 bg-[#DFF1EA] rounded">
                  <img className="w-[10px]" src={time} alt="time_icon" />
                </div>
              </div>
              <div className="relative flex items-center justify-center w-full bg-[#25A249] rounded-[30px] h-6 my-4">
                <p className="text-[10px] text-[#ffffff] font-normal z-20">
                  NOV {currentYear}
                </p>
                <div className="absolute right-0 flex items-center justify-center w-[40%] bg-[#8AC19B] rounded-r-[30px] h-[22px] my-4"></div>
              </div>
              {/* <p className='text-[9px] text-[#667085] font-normal'>
                          5 days till end date
                       </p> */}
            </motion.div>
          </div>

          {/*THIRD CONTAINER*/}
          {/* <div className='relative top-[190px] flex flex-col items-start w-[90%] mt-8 pb-10 md:top-32 lg:top-36'>
                  <p className='text-base text-black font-semibold lg:text-lg xl:text-[22px]'>
                      A step by step guide              
                  </p>

                  <div className='w-full relative mt-3 xl:mt-5'>
                      <iframe height="350px" width="100%" className='rounded-md xl:rounded-lg' 
                       src="https://www.youtube.com/embed/iT1d1kqZGh4" 
                       title="IBASS Video"
                       allowFullScreen
                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                       >
                      </iframe>
                  </div>
              </div> */}
        </div>

        {/*RIGHT CONTAINER TABLET >>>*/}
        <div className="hidden md:flex flex-col items-center justify-between w-[30%] px-5 mt-0 lg:px-6 xl:w-[25%]">
          <motion.div
            animate={{
              opacity: [0, 0.3, 0.3, 0.3, 1],
              scale: 1,
              x: ["25%", "0%"],
            }}
            transition={{ duration: 0.6, delay: 0.2 }}
            initial={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-start justify-center w-full border-[1px] border-[#DDE1E6] rounded p-4 xl:p-5 xl:rounded-md"
          >
            <div className="flex items-center justify-between w-full">
              <p className="text-[11px] text-[#101828] font-semibold xl:text-sm">
                EVENTS
              </p>
              <div className="flex items-center justify-center w-6 h-6 bg-[#DFF1EA] rounded xl:w-8 xl:h-8">
                <img
                  className="w-[10px] xl:w-[12px]"
                  src={calendar}
                  alt="calendar_icon"
                />
              </div>
            </div>
            <div className="flex flex-col items-start w-full mt-4 xl:mt-5">
              {/* <p className='text-[10px] text-[#667085] font-medium xl:text-sm'>
                                    JUNE
                                </p> */}
              <p className="text-2xl text-[#101828] font-bold xl:text-3xl xl:pt-[2px]">
                {examYear}
              </p>
              <p className="text-[10px] text-[#667085] font-normal lg:pt-1 xl:text-xs xl:pt-[6px]">
                Upcoming JAMB exam (UTME)
              </p>
            </div>
          </motion.div>

          <motion.div
            animate={{
              opacity: [0, 0.3, 0.3, 0.3, 1],
              scale: 1,
              x: ["25%", "0%"],
            }}
            transition={{ duration: 1.2, delay: 0.6 }}
            initial={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-start justify-start w-full border-[1px] border-[#DDE1E6] rounded p-4 mt-7 xl:p-5 xl:rounded-md"
          >
            <div className="flex items-start justify-between w-full">
              <div>
                <p className="text-[11px] text-[#101828] font-semibold xl:text-sm">
                  COUNTDOWN
                </p>
                <p className="text-[10px] text-[#667085] font-normal w-[100%] pt-1 xl:text-xs">
                  For registration announcement coming soon
                </p>
              </div>
              <div className="flex items-center justify-center w-6 h-6 bg-[#DFF1EA] rounded xl:w-8 xl:h-8">
                <img
                  className="w-[10px] xl:w-[12px]"
                  src={time}
                  alt="time_icon"
                />
              </div>
            </div>
            <div className="relative flex items-center justify-center w-full bg-[#25A249] rounded-[30px] h-6 my-4 lg:my-3 xl:h-8 xl:my-4">
              <p className="text-[10px] text-[#ffffff] font-normal z-20 xl:text-xs">
                NOV {currentYear}
              </p>
              <div className="absolute right-0 flex items-center justify-center w-[40%] bg-[#8AC19B] rounded-r-[30px] h-[24px] my-4 xl:h-[32px]"></div>
            </div>
            {/* <p className='text-[10px] text-[#667085] font-normal xl:text-xs'>
                              5 days till end date
                           </p> */}
          </motion.div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Overview;
